import { IntlShape } from 'react-intl';
import { readM24Error } from '../music24/utils/parseM24LimitError';
import { workspaceMessages } from '../workspaces/workspaceMessages';
import { teamErrorMessage } from './teamErrorMessage';

/** `team.leave` answers M24_TEAM_NOT_A_MEMBER when the person already left or was removed. */
export function isNotAMemberError(error: unknown): boolean {
  return readM24Error(error)?.code === 'M24_TEAM_NOT_A_MEMBER';
}

/**
 * A `team.leave` error of the person who leaves, as a sentence. M24_TEAM_NOT_A_MEMBER tells them
 * that they are out already. The owner's copy ("This person is not a member") is for a removal.
 */
export function leaveErrorMessage(intl: IntlShape, error: unknown, workspaceName: string): string {
  if (isNotAMemberError(error)) {
    return intl.formatMessage(workspaceMessages.noLongerMember, { workspace: workspaceName });
  }
  return teamErrorMessage(intl, error);
}
